//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { validSubdomain } from "@Shared/@Utils/validation-rules";
import ClipboardJS from "clipboard";
import { delay } from "@Shared/utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangeBrokerage",
  components: {
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    subdomain: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(15),
      validSubdomain
    }
  },
  props: {
    accountDetails: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      type: "accountCustomization",
      tooltipPosition: "top",
      subdomain: this.accountDetails.accountSubdomain,
      clipboardTitle: "Copied to clipboard",
      showBrokerTooltip: false,
      showClientTooltip: false
    };
  },
  computed: {
    isDisabled() {
      const permission = this.permissions[this.type];
      return permission !== "write";
    },
    disabledTooltipTitle() {
      return this.$t("settings.availableInDoorrProPlan");
    },
    getBrokerDomain() {
      return this.$options.filters.portalDomain("broker", "false");
    },
    getClientDomain() {
      return this.$options.filters.portalDomain("client", "false");
    },
    isFormValid() {
      return !this.$v.$invalid;
    }
  },
  watch: {
    isFormValid: {
      handler(valid) {
        this.$emit("allow-save", valid);
      }
    }
  },
  methods: {
    handleInitialSubmit() {
      this.$emit("initial-submit");
    },
    handleSubmit() {
      if (this.isFormValid) {
        this.$emit("submit", this.subdomain);
      }
    },
    async handleCopyBrokerage() {
      const clipboard = new ClipboardJS("#copy-link-broker", {
        text: () => {
          return `${this.getBrokerDomain}${this.subdomain}`;
        }
      });
      this.showBrokerTooltip = true;
      await this.$nextTick();
      $("#copy-link-broker").tooltip("show");
      clipboard.on("success", async () => await this.hideTooltipBroker());
    },
    async handleCopyClient() {
      const clipboard = new ClipboardJS("#copy-link-client", {
        text: () => {
          return `${this.getClientDomain}${this.subdomain}`;
        }
      });
      this.showClientTooltip = true;
      await this.$nextTick();
      $("#copy-link-client").tooltip("show");
      clipboard.on("success", async () => await this.hideTooltipClient());
    },
    async hideTooltipBroker() {
      await delay(1000);
      $("#copy-link-broker").tooltip("hide");
      this.showBrokerTooltip = false;
    },
    async hideTooltipClient() {
      await delay(1000);
      $("#copy-link-client").tooltip("hide");
      this.showClientTooltip = false;
    },
    handleFormChange() {
      this.$emit("form-change", "changeBrokerage");
      this.$emit("allow-save", this.isFormValid);
    }
  }
});